<template>
  <div class="card card-body rounded-top">
    <component-table
      entityType="profile"
      actionsWidth="300px"
      :actions="actions"
      :columns="columns"
      :data="list"
      :total="count"
      :hideAddButton="true"
      @view="goToProfile($event.id)"
      @edit="goToEdit($event.id)"
      @delete="showDeleteDialog($event.id)"
      @roles="goToRoles($event.id)"
    />
  </div>
</template>

<script>
import ComponentTable from '@/components/table/Table';
import { listMixin } from '@/mixins/list';
import { VIEW_ACTION, EDIT_ACTION, DELETE_ACTION, ROLES_ACTION } from '@/utils/constants';

// @vuese
// Lista profili
// @group Profile
export default {
  mixins: [
    listMixin('profile', {
      listError: 'messages.profile.listError',
      getError: 'messages.profile.getError',
      added: 'messages.profile.added',
      addError: 'messages.profile.addError',
      updated: 'messages.profile.updated',
      updateError: 'messages.profile.updateError',
      deleteConfirm: 'messages.profile.deleteConfirm',
      deleted: 'messages.profile.deleted',
      deleteError: 'messages.profile.deleteError'
    })
  ],
  components: { ComponentTable },

  data() {
    return {
      columns: [{ name: 'email', displayName: 'columns.userName', action: VIEW_ACTION.event }],
      actions: [
        { ...VIEW_ACTION, permissions: 'USER.GET' },
        { ...ROLES_ACTION, permissions: 'USER.ROLE_MANAGE' },
        { ...EDIT_ACTION, permissions: 'USER.UPDATE' },
        { ...DELETE_ACTION, permissions: 'USER.DELETE' }
      ]
    };
  },

  methods: {
    // @vuese
    // Przenosi do szczegółów profilu
    goToProfile(profileId) {
      this.$router.push({ name: 'profile', params: { profileId } });
    },
    // @vuese
    // Przenosi do edycji
    goToEdit(profileId) {
      this.$router.push({ name: 'profileEdit', params: { profileId } });
    },
    // @vuese
    // Przenosi do edycji ról
    goToRoles(profileId) {
      this.$router.push({ name: 'profileRoles', params: { profileId } });
    }
  }
};
</script>
